import React from "react";

import classNames from "classnames";
import PropTypes from "prop-types";

import "./tag.scss";

const Tag = ({
  children,
  variant = null,
}) => (
  <div className={classNames("tag", variant && `tag--${variant}`)}>{children}</div>
);

Tag.propTypes = {
  children: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(["learn-topic", "event"]),
};

export default Tag;
